// extracted by mini-css-extract-plugin
export default {"username":"userMenuLabel_username__lSm5m","first-name":"userMenuLabel_first-name__-sJW7","last-name":"userMenuLabel_last-name__CKe0Z","profile":"userMenuLabel_profile__e5zHF"};